import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {
  Divider,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import SelectFieldMateriasComponent from '../../../materias/components/SelectFieldMaterias';
import SelectFieldSeccionesComponent from '../../../secciones/components/SelectFieldSecciones';
import {
  allBloquesDocenteAction,
  asignarBloquesDocentesAction,
  deleteBloquesDocentesAction,
} from '../../DocentesAction';

const BloquesDocentesComponent = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const docentesStore = Redux.useSelector((state) => state.docentes);

  // const materias = docentesStore.activo?.materias ?? [];
  // const secciones = docentesStore.activo?.secciones ?? [];
  const bloquesHoras = docentesStore.allBloquesHoras ?? [];

  const [idMateria, setIdMateria] = React.useState('');
  const [idSeccion, setIdSeccion] = React.useState('');
  const [bloques, setBloques] = React.useState('');
  const [loadingDelete, setLoadingDelete] = React.useState(null);

  const [materias, setMaterias] = React.useState('');
  const [secciones, setSecciones] = React.useState('');

  React.useEffect(() => {
    async function fechtData() {
      await allBloquesDocenteAction(dispatch, {
        idDocente: docentesStore.activo.id,
      });

      docentesStore.activo?.materias.forEach((el) => {
        setMaterias((prev) => [...prev, el.materia]);
      });
      docentesStore.activo?.secciones.forEach((el) => {
        setSecciones((prev) => [...prev, el.seccion]);
      });
    }
    fechtData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      <LoadingWidget
        isLoading={docentesStore.loadingAll || loadingDelete}
        text={
          loadingDelete ? 'Eliminando asignacion...' : 'Asignando materia...'
        }
      />

      <Grid item md={4}>
        <SelectFieldMateriasComponent
          value={idMateria}
          isAll={false}
          data={materias}
          onChange={(idMaterias) => setIdMateria(idMaterias)}
        />
      </Grid>
      <Grid item md={4}>
        <SelectFieldSeccionesComponent
          value={idSeccion}
          isAll={false}
          data={secciones}
          onChange={(idSeccion) => setIdSeccion(idSeccion)}
        />
      </Grid>
      <Grid item md={2}>
        <TextField
          fullWidth
          size="small"
          type="number"
          required
          label={'Bloques'}
          value={bloques}
          onChange={(e) => setBloques(e.target.value)}
          id={'bloques'}
          InputProps={{
            inputProps: { min: 1, max: 12 },
          }}
        />
      </Grid>

      <Grid item md={2}>
        <BotonComponent
          size="sm"
          colorIcon="white"
          click={async () => {
            const res = await asignarBloquesDocentesAction(
              { dispatch, notify },
              {
                idEntidad: entidadesStore.activo.id,
                idDocente: docentesStore.activo.id,
                idSeccion,
                idMateria,
                bloques: Number(bloques),
              },
            );
            if (res) {
              setIdMateria('');
              setIdSeccion('');
              setBloques('');
            }
          }}
          disabled={!idMateria || !idSeccion || bloques === 0 || bloques === ''}
          icon={true}
          addIcon
          green
          mr={2}
        />
      </Grid>

      <Grid item md={12}>
        <Divider sx={{ my: 1 }} />
        <Typography variant="h5" color="initial">
          Asignados
        </Typography>
        <TableContainer>
          <Table size="small" aria-label="materias">
            <TableHead>
              <TableRow>
                {loginStore.isRoot ? <TableCell>ID</TableCell> : null}
                <TableCell>Materia</TableCell>
                <TableCell>Bloques</TableCell>
                <TableCell>Sección</TableCell>
                <TableCell>Acción</TableCell>
              </TableRow>
            </TableHead>
            {bloquesHoras.length > 0 && (
              <TableBody>
                {bloquesHoras.map((el) => (
                  <TableRow
                    key={el.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    {loginStore.isRoot ? <TableCell>{el.id}</TableCell> : null}
                    <TableCell>{el.materia.nombre}</TableCell>
                    <TableCell>{el.bloques}</TableCell>
                    <TableCell>{el.seccion.nombre}</TableCell>
                    <TableCell>
                      <Tooltip
                        describeChild
                        title="Eliminar seccion"
                        placement="top"
                      >
                        <IconButton
                          color="error"
                          size="small"
                          aria-label="Eliminar seccion"
                          onClick={async () => {
                            setLoadingDelete(true);
                            await deleteBloquesDocentesAction(
                              { dispatch, notify },
                              docentesStore.activo.id,
                              el.id,
                            );
                            setLoadingDelete(false);
                          }}
                        >
                          <DeleteForeverIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default BloquesDocentesComponent;
